module.exports = __webpack_public_path__ + "img/minus-circle.087ee178.svg";